import { useState } from 'react';

import { SmallBoldUnderlinedTextDropdown } from '#src/components/SmallBoldUnderlinedTextDropdown/SmallBoldUnderlinedTextDropdown.tsx';

export const useScopeState = () => {
  const [hirerScopedIndicator, setHirerScopedIndicator] = useState<
    boolean | null
  >(null);

  return {
    hirerScopedIndicator,
    setHirerScopedIndicator,
  };
};

type Props = ReturnType<typeof useScopeState>;

const options = [
  { value: null, label: 'All subscriptions' },
  { value: false, label: 'Partner subscriptions' },
  { value: true, label: 'Hirer subscriptions' },
];

export const ScopePicker = ({
  hirerScopedIndicator,
  setHirerScopedIndicator,
}: Props) => (
  <SmallBoldUnderlinedTextDropdown<boolean | null>
    options={options}
    value={hirerScopedIndicator}
    setValue={setHirerScopedIndicator}
  />
);
